/** Small RFC-4180 style parser: quoted cells, escaped quotes, CRLF, commas inside quotes. */
export function parseCsv(text: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let cell = "";
  let quoted = false;
  const src = text.replace(/^﻿/, "");
  for (let i = 0; i < src.length; i++) {
    const ch = src[i] as string;
    if (quoted) {
      if (ch === '"' && src[i + 1] === '"') {
        cell += '"';
        i++;
      } else if (ch === '"') quoted = false;
      else cell += ch;
    } else if (ch === '"') quoted = true;
    else if (ch === ",") {
      row.push(cell);
      cell = "";
    } else if (ch === "\n" || ch === "\r") {
      if (ch === "\r" && src[i + 1] === "\n") i++;
      row.push(cell);
      cell = "";
      if (row.some((c) => c.trim() !== "")) rows.push(row);
      row = [];
    } else cell += ch;
  }
  row.push(cell);
  if (row.some((c) => c.trim() !== "")) rows.push(row);
  return rows;
}

export interface ImportedFaq {
  question: string;
  answer: string;
  chatInitiator: boolean;
}

/** Reads a CSV with a `question` and an `answer` column (any order, any case; optional `chat initiator`). */
export function faqsFromCsv(text: string): { faqs: ImportedFaq[]; error?: string } {
  const [header, ...rows] = parseCsv(text);
  if (!header) return { faqs: [], error: "The file is empty." };
  const idx = (names: string[]) => header.findIndex((h) => names.includes(h.trim().toLowerCase().replace(/[\s_-]+/g, "")));
  const q = idx(["question", "questions", "pregunta"]);
  const a = idx(["answer", "answers", "respuesta"]);
  const ci = idx(["chatinitiator", "initiator", "starter"]);
  if (q < 0 || a < 0) return { faqs: [], error: "The first row must have the columns “question” and “answer”." };
  const faqs = rows
    .map((r) => ({ question: (r[q] ?? "").trim(), answer: (r[a] ?? "").trim(), chatInitiator: ci >= 0 && /^(true|yes|si|sí|1|x)$/i.test((r[ci] ?? "").trim()) }))
    .filter((f) => f.question && f.answer);
  return faqs.length ? { faqs } : { faqs: [], error: "No rows with both a question and an answer were found." };
}
